export default {
    storeManagementGoodsPriceSurchargeInfosList: [],
    isStoreManagementGoodsPriceSurchargeInfosDialogOpen: false,
    isStoreManagementGoodsPriceSurchargeInfosAddSurchargeSectionOpen: false,
    selectedStoreId: '',
    editSurchargeItem: {},
};
